export const trimWhitespace = (strValue: unknown): string => {
  if (strValue == null) {
    return '';
  }

  return String(strValue)
    .trim()
    .replace(/\s{2,}/g, ' ');
};
